/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-11-26 09:11:35
 * @LastEditors: shi
 * @LastEditTime: 2020-12-05 19:34:03
 */
import request from './request';

const http = {
  get(url, params, bolb) {
    const config = {
      method: 'get',
      url: url
    };
    if (bolb) {
      config.responseType = 'arraybuffer';
    }
    if (params) config.params = params;
    return request(config);
  },
  post(url, params) {
    const config = {
      method: 'post',
      url: url
    };
    if (params) config.data = params;
    return request(config);
  },
  put(url, params) {
    const config = {
      method: 'put',
      url: url
    };
    if (params) config.data = params;
    return request(config);
  },
  delete(url, params) {
    const config = {
      method: 'delete',
      url: url
    };
    if (params) config.data = params;
    return request(config);
  }
};

export default http;
